import { useEffect, useState } from "react";

const Timer = ({setSendCode}:any) => {
  const otpTime = localStorage.getItem("otpTime");
  const [reciveCode, setReciveCode] = useState<boolean>(true);
  const [seconds, setSeconds] = useState<number>(30);
  const [minutes, setMinutes] = useState<number>(1);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          setReciveCode(false);
        } else {
          setSeconds(59);
          setMinutes(0);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    getRecievCode();
  }, []);

  const getDeadTime = () => {
    let deadline = new Date();
    const remindTime = otpTime ? Date.parse(otpTime) - deadline.getTime() : 0;
    if (otpTime && reciveCode && remindTime > 0) {
        setSeconds(Math.floor((remindTime / 1000) % 60));
        setMinutes(Math.floor((remindTime / 1000 / 60) % 60));
    } else {
      deadline.setSeconds(deadline.getSeconds() + 90);
      localStorage.setItem("otpTime", deadline.toString());
    }
  };
  const getRecievCode = () => {
    setSendCode(true);
    setMinutes(1);
    setSeconds(30);
    setReciveCode(true);
    getDeadTime();
  };

  return !reciveCode ? (
    <div onClick={getRecievCode} className="verifyRetryContainer">
      <div className="icon2-replay verifyRetryIcon" />
      <div>ارسال مجدد کد</div>
    </div>
  ) : (
    <div className="timerText">
      0{minutes}:{seconds < 10 ? `0${seconds}` : seconds}
    </div>
  );
};
export default Timer;
